/**
 * 갱신안내 팝업 "N일간 보지 않기" (기획서 5p)
 *
 * 기간은 파르나스 확정 전이라 임시로 7일이다. 아래 상수만 바꾸면 된다.
 *
 * 저장은 localStorage 를 쓴다. 서버에 둘 만한 값이 아니고, 기기별로 판단하면 충분하다.
 * 회원 단위로 키를 나누는 이유는 한 기기에서 다른 계정으로 로그인했을 때
 * 앞사람의 "보지 않기"를 물려받지 않게 하기 위해서다.
 */

// todo 파르나스 확정 후 조정 (기획서 5p 코멘트)
export const NOTICE_HIDE_DAYS = 7

const KEY_PREFIX = "renewal_notice_hidden_until"

function storageKey(memberId) {
    return memberId ? `${KEY_PREFIX}:${memberId}` : KEY_PREFIX
}

/**
 * 지금 팝업을 감춰야 하는지
 *
 * @param {Number|String} memberId memberMetaId
 * @returns {Boolean}
 */
export function isNoticeHidden(memberId) {
    try {
        const until = Number(localStorage.getItem(storageKey(memberId)))
        if (!until) return false

        // 만료됐으면 흔적을 지워 두어 키가 쌓이지 않게 한다.
        if (Date.now() >= until) {
            localStorage.removeItem(storageKey(memberId))
            return false
        }
        return true
    } catch (e) {
        // 시크릿 모드 등으로 localStorage 를 쓸 수 없으면 그냥 노출한다.
        return false
    }
}

/**
 * 오늘부터 NOTICE_HIDE_DAYS 일간 감춘다.
 *
 * @param {Number|String} memberId memberMetaId
 */
export function hideNoticeFor(memberId) {
    try {
        const until = Date.now() + NOTICE_HIDE_DAYS * 24 * 60 * 60 * 1000
        localStorage.setItem(storageKey(memberId), String(until))
    } catch (e) {
        // 저장하지 못해도 기능이 막히지는 않는다. 다음에 또 뜰 뿐이다.
    }
}
